"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Checkbox = exports.ResultHeaderRow = exports.ResultRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var lookupV2_1 = require("./lookupV2");
var conditional_1 = require("../../conditional/conditional");
var svg_icons_1 = __importDefault(require("../../svgs/svg-icons"));
var ui_common_1 = require("@codametrix/ui-common");
var SugggestedCodeType = ui_common_1.commonEnums.SugggestedCodeType;
var ResultRow = function (props) {
    var _a, _b, _c;
    var activeIdx = props.activeIdx, activeSelection = props.activeSelection, codeInfo = props.codeInfo, idx = props.idx, _d = props.idxOffset, idxOffset = _d === void 0 ? 0 : _d, _e = props.allowCodeRemove, allowCodeRemove = _e === void 0 ? false : _e, _f = props.transactionGuid, transactionGuid = _f === void 0 ? '' : _f, _g = props.isSuggestedRow, isSuggestedRow = _g === void 0 ? false : _g;
    var codeData = codeInfo;
    //const index = idxOffset + idx;
    var index = idx;
    var isFromSuggestedResult = activeSelection === lookupV2_1.ResultType.SUGGESTED_RESULTS;
    var isInCurrentTnx = (_b = (_a = codeData === null || codeData === void 0 ? void 0 : codeData.transaction_guids) === null || _a === void 0 ? void 0 : _a.includes(transactionGuid)) !== null && _b !== void 0 ? _b : false;
    var _h = __read((0, react_1.useState)(isInCurrentTnx), 2), isChecked = _h[0], setIsChecked = _h[1];
    (0, react_1.useEffect)(function () {
        if (isInCurrentTnx !== isChecked)
            setIsChecked(isInCurrentTnx);
    }, [codeInfo]);
    var activeIndex = (isSuggestedRow && activeSelection === lookupV2_1.ResultType.SUGGESTED_RESULTS) ||
        (!isSuggestedRow && activeSelection === lookupV2_1.ResultType.SEARCH_RESULTS)
        ? activeIdx
        : -1;
    var styleClasses = [
        'search-result',
        "".concat((_c = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType) === null || _c === void 0 ? void 0 : _c.toLowerCase(), "-code"),
        { 'search-result-submittable': activeIndex === index }
    ];
    var handleClick = function (event) {
        var checked = !isChecked;
        setIsChecked(checked); // Toggle the state
        var opType = checked ? 'add' : 'delete';
        props.handleClick(event, codeInfo, opType);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-idx": index, className: (0, classnames_1["default"])(styleClasses), "data-dd-action-name": "~Select code (".concat(codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType.toLowerCase(), "-code)"), onClick: function (ev) { return handleClick(ev); } }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [isSuggestedRow, allowCodeRemove] }, { children: (0, jsx_runtime_1.jsx)(exports.Checkbox, { value: isChecked, disabled: true, onChange: function () { } }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-label search-label" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-chip" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "chip" }, { children: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code })) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-code-description" }, { children: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.description }))] }), "".concat(isFromSuggestedResult ? 'suggested' : 'search', "-result-").concat(index)));
};
exports.ResultRow = ResultRow;
var ResultHeaderRow = function (props) {
    var label = props.label, _a = props.isSuggestedRow, isSuggestedRow = _a === void 0 ? false : _a, _b = props.allowCodeRemove, allowCodeRemove = _b === void 0 ? false : _b, opType = props.opType, handleSelectAll = props.handleSelectAll, handleUnselectAll = props.handleUnselectAll, activeIndex = props.activeIndex, sectionStartIndex = props.sectionStartIndex, activeSelection = props.activeSelection;
    var styleClasses = (0, classnames_1["default"])('result-header', {
        'suggested-result-header': isSuggestedRow
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: [(0, jsx_runtime_1.jsx)("span", { children: label }), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [isSuggestedRow, allowCodeRemove] }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "action-container" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])('select-all', {
                                highlighted: activeSelection === lookupV2_1.ResultType.SUGGESTED_RESULTS &&
                                    sectionStartIndex === activeIndex
                            }), onClick: function (ev) { return handleSelectAll(ev, opType); } }, { children: "add all" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])('unselect-all', {
                                highlighted: activeSelection === lookupV2_1.ResultType.SUGGESTED_RESULTS &&
                                    sectionStartIndex + 1 === activeIndex
                            }), onClick: function (ev) { return handleUnselectAll(ev, opType); } }, { children: "remove all" }))] })) }))] })));
};
exports.ResultHeaderRow = ResultHeaderRow;
exports.ResultHeaderRow.displayName = 'ResultHeaderRow';
var Checkbox = function (_a) {
    var _b = _a.value, value = _b === void 0 ? false : _b, label = _a.label, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d;
    var _e = __read((0, react_1.useState)(value), 2), checked = _e[0], setChecked = _e[1];
    // Sync state with the `value` prop if it changes
    (0, react_1.useEffect)(function () {
        if (value !== checked) {
            setChecked(value);
        }
    }, [value]);
    var handleClick = function (event) {
        if (disabled)
            return;
        var newChecked = !checked;
        setChecked(newChecked);
        onChange(newChecked);
    };
    var containerClasses = (0, classnames_1["default"])('cmx-custom-checkbox', {
        checked: checked
    });
    var checkboxClasses = (0, classnames_1["default"])('custom-checkbox', {
        checked: checked,
        'checkbox-disabled': disabled
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: containerClasses, onClick: handleClick }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: checkboxClasses }, { children: checked && ((0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeCheckSVG20", svgIconSize: "12", svgIconClass: "check-mark" })) })), label && (0, jsx_runtime_1.jsx)("span", __assign({ className: "checkbox-label" }, { children: label }))] })));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=result-row.js.map